import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {encodingClothsImages} from '../cloths-mockup';
import {encodingSymbolsImages} from '../symbols-mockup';

export abstract class GeneralSymbolsEncodingComponent implements OnInit, OnChanges {

  @Input() counter: number;
  @Input() level: number;
  @Output() currentEncodingChange = new EventEmitter<number[][]>();

  // Each array contains a part of the possible encodings of the length NumberOfEncodings
  // Each array contains encodings which are in at least 2 positions different.
  goodEncodings1: number[][];
  goodEncodings2: number[][];

  // The created encodings used in the actual exercise
  encodings: number[][];
  goodEncoding: number[][];
  generalEncoding: number[][];
  symbolImages = encodingSymbolsImages;
  clothsImages = encodingClothsImages;

  constructor() { }

  ngOnInit() {
  }

  /**
   * Generate a new encoding exercise only when the counter or the level change.
   * The encoding exercises can have other input variable, which we have to ignore here.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.level || changes.counter) {
      this.generateRandomExercise();
    }
  }

  initValues() {
    this.goodEncodings1 = [[0, 0], [1, 1]];
    this.goodEncodings2 = [[0, 1], [1, 0]];
  }

  /**
   * Here we define for each encoding exercise, what has to happen if we create a new exercise.
   */
  abstract generateRandomExercise();

  /**
   * Returns the number of words that we want to encode
   */
  abstract getNumberOfEncodings();

  /**
   * Returns the length of all the encodings.
   * The number of symbols an encodings consist of.
   */
  abstract getEncodingLength();

  /**
   * Generate all possible encodings with 2 symbols and the a certain length
   * @param length of the encoding
   */
  generateAllEncodings(length: number) {
    // We already have the encodings for length = 2.
    for (let i = 0; i < length - 2; i++) {
      const temp = [];
      this.cloneDeepArray(temp, this.goodEncodings1);
      this.addSymbolToEncoding(this.goodEncodings1, this.goodEncodings2);
      this.addSymbolToEncoding(this.goodEncodings2, temp);
    }
  }

  addSymbolToEncoding(mainEncoding: number[][], helperEncoding: number[][]) {
    for (let i = 0; i < mainEncoding.length; i++) {
      mainEncoding[i].push(0);
    }
    for (let j = 0; j < helperEncoding.length; j++) {
      const tmp = Object.assign([], helperEncoding[j]);
      tmp.push(1);
      mainEncoding.push(tmp);
    }
  }

  /**
   * Generate a list of encodings, where all the encodings are different in at most 2 positions
   * @param numberOfEncodings the number of different encodings that we want to get
   */
  generateGoodCoding(numberOfEncodings: number) {
    const uniqueIndexes = this.getUniqueIndexes(0, this.goodEncodings1.length, numberOfEncodings);

    const choosedArray = Math.floor((Math.random() * 2) + 1);
    const goodCoding = [];
    for (let i = 0; i < numberOfEncodings; i++) {
      if (choosedArray === 1) {
        goodCoding[i] = this.goodEncodings1[uniqueIndexes[i]];
      } else {
        goodCoding[i] = this.goodEncodings2[uniqueIndexes[i]];
      }
    }

    this.goodEncoding = goodCoding;
  }

  /**
   * Generate a list of encodings. But this time there are no further rules.
   * Only pick randomly unique encodings
   * @param numberOfEncodings the number of encodings we pick
   */
  generateCoding(numberOfEncodings: number) {
    const uniqueIndexes = this.getUniqueIndexes(0, this.goodEncodings1.length, numberOfEncodings);

    const coding = [];
    for (let i = 0; i < numberOfEncodings; i++) {
      const randomEncodingArray = Math.floor((Math.random() * 2) + 1);
      if (randomEncodingArray === 1) {
        coding[i] = this.goodEncodings1[uniqueIndexes[i]];
      } else {
        coding[i] = this.goodEncodings2[uniqueIndexes[i]];
      }
    }
    this.generalEncoding = coding;
  }

  getUniqueIndexes(from: number, to: number, length: number) {
    let counter = 0;
    const idx = [];
    while (counter < length) {
      const randId = Math.floor((Math.random() * to) + from);
      if (idx.indexOf(randId) === -1) {
        idx.push(randId);
        counter ++;
      }
    }

    return idx;
  }

  getSymbolImage(idx: number) {
    return this.symbolImages[idx];
  }

  getClothsImage(idx: number) {
    return this.clothsImages[idx];
  }

  cloneDeepArray(copy: number[][], original: number[][]) {
    for (let i = 0; i < original.length; i++) {
      copy[i] = Object.assign([], original[i]);
    }
  }

  getCodeWidth() {
    const width = 100 / this.encodings[0].length;
    return width.toString() + '%';
  }

  /**
   * Compare two arrays arr1 with arr2
   * Return true if both arrays are the same. (same length and same values in the same order)
   * @param arr1
   * @param arr2
   */
  compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

}
